import MotorClaims from './MotorClaims';
export default MotorClaims;